import INewsArticle, {
    INewsArticleAuthor,
    IAuthorSocialMedia,
    INewsArticleFeatureImage,
} from "../models/INewsArticle";
import { allAreUndefined, parseStringResponse, parseDateResponse } from "./utils";
import artictleContentResponseConverter from "./artictleContentResponseConverter";

export default function convertArticleResponse(response: any): INewsArticle {
    const { author, codename, content, title, publicationDate, featureImage, url } = response;

    return {
        author: convertAuthorResponse(author),
        codename: parseStringResponse(codename),
        content: artictleContentResponseConverter(content),
        title: parseStringResponse(title),
        publicationDate: parseDateResponse(publicationDate),
        featureImage: convertFeatureImageResponse(featureImage),
        url: parseStringResponse(url),
    };
}

function convertAuthorResponse(authorResponse: any): INewsArticleAuthor | undefined {
    const { name, description, profilePicture } = authorResponse;

    const _name = parseStringResponse(name);
    const _description = parseStringResponse(description);
    const _profilePictureUrl = parseStringResponse(profilePicture);
    const _socialMedia = convertAuthorSocialMediaResponse(authorResponse);

    if (allAreUndefined(_name, _description, _profilePictureUrl, _socialMedia)) return undefined;

    return {
        name: _name,
        description: _description,
        profilePictureUrl: _profilePictureUrl,
        socialMedia: _socialMedia,
    };
}

function convertAuthorSocialMediaResponse(authorResponse: any): IAuthorSocialMedia | undefined {
    const { twitter, facebook, instagram } = authorResponse;

    const _twitterUrl = parseStringResponse(twitter);
    const _facebookUrl = parseStringResponse(facebook);
    const _instagramUrl = parseStringResponse(instagram);

    if (allAreUndefined(_twitterUrl, _facebookUrl, _instagramUrl)) return undefined;

    return {
        twitterUrl: _twitterUrl,
        facebookUrl: _facebookUrl,
        instagramUrl: _instagramUrl,
    };
}

function convertFeatureImageResponse(
    featureImageResponse: any
): INewsArticleFeatureImage | undefined {
    const { name, description, url } = featureImageResponse;

    const _name = parseStringResponse(name);
    const _description = parseStringResponse(description);
    const _url = parseStringResponse(url);

    if (allAreUndefined(_name, _description, _url)) return undefined;

    return {
        name: _name,
        description: _description,
        url: _url,
    };
}
